import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Balance = () => {
    document.title = "Balans";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Hesabatlar", value: "/reports" },
        { name: "Balans", value: "/reports/balance" },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Balans</h2>
                    <p>
                        Sistemdə olan pul vəsaitinin göstəricisidir. Nağd və nağdsız şəkildə ödənişlərin nəticəsində <b>balans</b> formalaşır.{" "}
                        <mark>Satış nöqtəsi</mark>nin balansı, kassa proqramından icra olunan əməliyyatların nəticəsində formalaşır. <mark>Hesab</mark> balansı,
                        nağdsız icra olunan əməliyyatların nəticəsində formalaşır.
                        <br />
                        Nümunədə Hesabatlar ⮞ Balans ilə bağlı məlumatların əks olunduğu səhifəyə keçid göstərilib
                    </p>
                    <img src="/images/reports/balance.gif" alt="Balans" />
                </article>
            </div>
        </div>
    );
};
